module.exports = __webpack_public_path__ + "img/icon-phone.4c203a3c.svg";